import { createSelector } from 'reselect';
import { getPromoCacheKey } from '../utils/promoCacheKey';

export const marketingKey = {
    PROMO_CODE: 'promoCode0',
    PRICE_ADJUSTMENT: 'PriceAdjustment0',
    FINAL_PRICE: 'FinalPriceTotal',
    CODE_DESCRIPTION: 'CalculationCodeDescription0',
};

export const promotionType = {
    MANUAL: 'manual',
    AUTO: 'auto',
    NONE: 'none',
};

export const getPromoState = (state, partNumber) => {
    const cacheKey = getPromoCacheKey(partNumber, state.userState?.user?.globalId);
    return state?.pdp?.promoState?.responses?.[cacheKey] || {};
};

export const getMarketingSpotData = createSelector([getPromoState], (promoState) => promoState?.response?.body?.MarketingSpotData || []);

export const getBaseMarketingSpotActivityData = createSelector([getMarketingSpotData], (marketingSpotData) =>
    marketingSpotData.flatMap((spot) => spot?.baseMarketingSpotActivityData || []),
);

export const getMarketingProperties = createSelector(
    [getBaseMarketingSpotActivityData],
    (activityData) =>
        activityData[0]?.properties?.reduce((acc, curr) => {
            acc[curr.baseMarketingKey] = curr.baseMarketingValue;
            return acc;
        }, {}) || {},
);

export const getPromotionApplied = createSelector([getMarketingProperties], (marketingProperties) => {
    const hasPromotionApplied = !!marketingProperties[marketingKey.PRICE_ADJUSTMENT];
    const promotionApplied = hasPromotionApplied
        ? marketingProperties[marketingKey.PROMO_CODE]
            ? promotionType.MANUAL
            : promotionType.AUTO
        : promotionType.NONE;
    return promotionApplied;
});

export const getSelectedPromoPrice = createSelector([getMarketingProperties, getPromotionApplied], (marketingProperties, promotionApplied) => ({
    marketingProperties,
    promotionApplied,
}));
